import { Controller } from '@hotwired/stimulus';
import { mount } from '@infakt/chat-panel';

export default class extends Controller {
  async connect() {
    await import('@infakt/chat-panel/chat-panel.css');

    const mainContainer = document.getElementById('chat-panel-container');

    if (!mainContainer) {
      return;
    }

    mount({
      container: mainContainer,
      env: {
        chatApiBaseUrl: this.element.dataset.chatPanelApiDomain,
        chatWssBaseUrl: this.element.dataset.chatPanelApiDomain,
        chatWssPath: '/chat/ws',
      },
    });
  }
}
